import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <section id="offer" className="bg-gradient-hero py-12 md:py-16 px-4 md:px-8 relative overflow-hidden" data-id="element-174">
      {/* Decorative Gold Blob */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/10 blur-[100px] rounded-full pointer-events-none" data-id="element-175" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-card border-2 border-gold/40 rounded-3xl px-6 py-10 md:p-12 shadow-gold text-center" data-id="element-177">
          {/* 1. Title */}
          <h2 className="text-xl md:text-2xl font-display font-bold text-foreground uppercase tracking-wider leading-snug" data-id="element-178">
            Acceso completo al Protocolo H.E.R.
          </h2>

          {/* 2. Anchor price (strikethrough) */}
          <p className="text-lg md:text-xl text-foreground/50 font-body font-medium line-through decoration-foreground/30 decoration-2 mt-4" data-id="element-179">
            $69.000
          </p>

          {/* 3. Main price */}
          <div className="mt-6" data-id="element-180">
            <p className="text-base md:text-lg text-foreground/70 font-body font-semibold mb-1" data-id="element-181">
              Hoy accedés por solo
            </p>
            <p className="text-5xl md:text-7xl font-display font-black text-gradient-gold glow-gold leading-none" data-id="element-182">
              $12.000
            </p>
            <p className="text-sm text-foreground/50 font-body font-medium mt-1" data-id="element-183">
              ARS
            </p>
          </div>

          {/* 4. Installments */}
          <div className="bg-gold/5 border border-gold/20 rounded-xl px-5 py-3 mt-6 max-w-sm mx-auto" data-id="element-184">
            <p className="text-sm md:text-base font-body font-semibold text-foreground/80 leading-snug" data-id="element-185">
              💳 También en 3 cuotas sin interés de $4.000
            </p>
            <p className="text-xs text-foreground/50 font-body font-medium mt-0.5" data-id="element-186">
              con Mercado Pago
            </p>
          </div>

          {/* Divider */}
          <div className="w-16 h-px bg-gold/20 mx-auto mt-8 mb-8" data-id="element-187" />

          {/* 5. Benefit */}
          <div className="space-y-1" data-id="element-188">
            <p className="text-base md:text-lg text-foreground/90 font-body font-medium" data-id="element-189">
              Acceso inmediato al programa completo
            </p>
            <p className="text-sm md:text-base text-foreground/60 font-body font-medium" data-id="element-190">
              Lo comprás una vez y es tuyo para siempre
            </p>
          </div>

          {/* 6. Value justification */}
          <p className="text-sm text-foreground/45 font-body font-medium italic mt-5 max-w-xs mx-auto leading-relaxed" data-id="element-191">
            Una inversión mínima para empezar a ver cambios reales.
          </p>

          {/* 7. Urgency */}
          <div className="mt-8 space-y-0.5" data-id="element-192">
            <p className="text-sm md:text-base text-accent font-body font-bold" data-id="element-193">
              Precio de lanzamiento por tiempo limitado
            </p>
            <p className="text-sm text-foreground/50 font-body font-medium" data-id="element-194">
              Después vuelve a $69.000
            </p>
          </div>

          {/* 8. CTA */}
          <div className="mt-8" data-id="element-195">
            <CTAButton className="w-full md:w-auto text-lg md:text-xl" data-id="element-196">
              ACCEDER AHORA
            </CTAButton>
          </div>

          {/* 9. Trust microcopy (stacked for mobile) */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4 mt-5" data-id="element-197">
            <span className="text-[13px] md:text-sm text-foreground/70 font-body font-medium" data-id="element-198">
              🔒 Pago 100% seguro
            </span>
            <span className="text-[13px] md:text-sm text-foreground/70 font-body font-medium" data-id="element-199">
              ✅ Garantía de 30 días
            </span>
            <span className="text-[13px] md:text-sm text-foreground/70 font-body font-medium" data-id="element-200">
              ⚡ Acceso inmediato al comprar
            </span>
          </div>

          {/* Guarantee */}
          <div className="flex flex-col items-center space-y-4 mt-10 pt-8 border-t border-border/30" data-id="element-201">
            <div className="inline-flex items-center gap-2 bg-secondary/20 px-5 py-2.5 rounded-full border border-secondary/30" data-id="element-202">
              <span className="text-lg" data-id="element-203">🛡️</span>
              <span className="text-secondary font-bold font-body text-[13px] md:text-sm" data-id="element-204">
                Garantía de 30 días (sin riesgo)
              </span>
            </div>
            <p className="text-[13px] md:text-sm text-foreground/70 font-body font-medium max-w-md mx-auto leading-relaxed" data-id="element-205">
              Probalo con calma. Si dentro de los 30 días sentís que el
              Protocolo H.E.R. no es para vos, me escribís, lo solicitás y te
              devuelvo el 100%. Sin vueltas ni condiciones.
            </p>
            <p className="text-xs text-foreground/50 font-body max-w-md mx-auto leading-relaxed" data-id="element-206">
              Válida para la compra del programa digital Protocolo H.E.R.
            </p>
          </div>

          {/* Trust Seals */}
          <div className="flex flex-col items-center gap-3 mt-8" data-id="element-207">
            <img src="https://cdn.magicpatterns.com/uploads/7qHzDsLZQadSacwja9UfzV/sellos_2.png" alt="Visa, Mastercard, American Express, PayPal, Mercado Pago" className="w-48 md:w-56 h-auto" data-id="element-208" />
            <img src="https://cdn.magicpatterns.com/uploads/tdA4AqADhgGePmHY6mrLkM/nb2-1775758553264-1.png" alt="Garantía 30 días devolución de dinero y SSL Seguro" className="w-40 md:w-48 h-auto" data-id="element-209" />
          </div>
        </motion.div>

        {/* Emotional closer */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center max-w-2xl mx-auto mt-12 space-y-3" data-id="element-210">
          <p className="text-xl md:text-2xl font-display font-bold text-gradient-gold leading-snug" data-id="element-211">
            No es tu cuerpo el problema
          </p>
          <p className="text-base md:text-lg font-body font-medium leading-relaxed" style={{
          color: 'rgba(255, 255, 255, 0.85)'
        }} data-id="element-212">
            Tu cuerpo no está fallando. Está cambiando. Y cuando entendés cómo
            funciona, todo empieza a ordenarse.
          </p>
        </motion.div>
      </div>
    </section>;
}